import { ArrowBack, ArrowForward } from "@mui/icons-material";
import { Box, Button, Grid, IconButton, Link, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { Divider } from "semantic-ui-react";
import { Link as RouterLink } from "react-router-dom";
import { fetchGoogleIdToken } from "../../app/services/firbaseService";
import { fetchMeinBildungsraumUserCode } from "../../app/services/meinBildungsraumOAuth/meinBildungsraumOAuthService";
import { useStore } from "../../app/stores/store";
import LoginForm from "../users/LoginForm";
import MailRegisterForm from "../users/MailRegisterForm";
import carousel from "./carousel.json";

export default observer(function HomePage() {
  const { accountStore, modalStore, translationStore: t } = useStore();
  const [carouselIdx, setCarouselIdx] = useState(() => 0);

  async function googleLogin() {
    var idToken = await fetchGoogleIdToken();
    accountStore.googleOAuth(idToken);
  }

  async function meinBildungsraumLogin() {
    await fetchMeinBildungsraumUserCode();
  }

  return (
    <>
      <Grid container sx={{
        overflowY: "auto"
      }}>
        <Grid container item xs={12} lg={6} bgcolor="#EBEAFF" p={6} direction="column" sx={{ height: '100vh' }}>
          <Grid item container display="flex" alignItems="center">
            <img src="/logo.svg" alt="" width={48} height={48} />

            <Typography fontWeight={400} fontSize="22px">Willkommen bei CoKoMo</Typography>
          </Grid>

          <Grid item container xs flex={1} display="flex" justifyContent="center" p={2}>
            <img src={carousel[carouselIdx].img} alt="" />
          </Grid>

          <Grid item xs>
            <Typography fontSize="36px" fontWeight={300} lineHeight="44px">{carousel[carouselIdx].title}</Typography>
            <Typography fontSize="16px" fontWeight={400} lineHeight="24px">{carousel[carouselIdx].desc}</Typography>
          </Grid>

          <Grid container item p={2} direction="column">
            <Grid item display="flex" justifyContent="center" alignItems="center">
              <IconButton
                color={carouselIdx === 0 ? "default" : "primary"}
                onClick={() => carouselIdx - 1 >= 0 && setCarouselIdx(carouselIdx - 1)}
              > <ArrowBack /> </IconButton>

              <Grid display="flex" gap={1} mx={2}>
                {
                  Array.from({ length: carousel.length }).map((_, index) => (
                    <Dot key={index} size="8px" color={carouselIdx === index ? "#483FA5" : "#BFBBF3"} />
                  ))
                }
              </Grid>

              <IconButton
                color={carouselIdx === carousel.length - 1 ? "default" : "primary"}
                onClick={() => carouselIdx + 1 < carousel.length && setCarouselIdx(carouselIdx + 1)}
              > <ArrowForward /> </IconButton>
            </Grid>

            <Grid item display="flex" justifyContent="center" gap={1}>
              <Typography>Mehr über CoKoMo?</Typography>
              <Link href="https://www.cokomo-it.de/">www.cokomo-it.de</Link>
            </Grid>
          </Grid>
        </Grid>

        <Grid container item xs={12} lg={6} bgcolor="white" direction="column" p={2} sx={{ height: '100vh' }}>
          <Grid flex={1} item xs justifyContent="center" alignItems="center" display="flex">
            <Box>
              {!accountStore.isLoggedIn ? (
                <>
                  <Typography fontSize="24px" lineHeight="32px" py={2}>Sign In</Typography>

                  <Box width="350px" py={1}>
                    <Button
                      style={{
                        justifyContent: "flex-start",
                        padding: "16px 20px",
                        borderRadius: "10px",
                        backgroundColor: "white",
                        color: "black",
                        fontSize: "16px"
                      }}
                      startIcon={<img src="/assets/login-icon-1.png" alt="" width={24} height={24} />}
                      size="large"
                      fullWidth
                      onClick={() => modalStore.openModal(<LoginForm />)}
                      variant="contained"
                    >
                      Sign In mit CoKoMo
                    </Button>
                  </Box>

                  {/* Hide 'Sign In mit Mein Bildungsraum' in Jann's feedback */}
                  {/* <Box width="350px" py={1}>
                    <Button
                      style={{
                        justifyContent: "flex-start",
                        padding: "16px 20px",
                        borderRadius: "10px",
                        backgroundColor: "white",
                        color: "black",
                        fontSize: "16px"
                      }}
                      startIcon={<img src="/assets/login-icon-3.png" alt="" width={24} height={24} />}
                      size="large"
                      fullWidth
                      variant="contained"
                      onClick={() => meinBildungsraumLogin()}>
                      Sign In mit Mein Bildungsraum
                    </Button>
                  </Box> */}

                  <Box width="350px" py={1}>
                    <Button
                      style={{
                        justifyContent: "flex-start",
                        padding: "16px 20px",
                        borderRadius: "10px",
                        backgroundColor: "white",
                        color: "black",
                        fontSize: "16px"
                      }}
                      startIcon={<img src="/assets/login-icon-2.png" alt="" width={24} height={24} />}
                      size="large"
                      fullWidth
                      variant="contained"
                      onClick={() => googleLogin()}>
                      Sign In mit Google
                    </Button>
                  </Box>
                </>
              ) : (
                <>
                  <Typography fontSize="24px" lineHeight="32px" py={2}>Welcome back {accountStore.user?.displayName}</Typography>

                  <Box width="350px" py={1}>
                    <Button
                      style={{
                        justifyContent: "flex-start",
                        padding: "16px 20px",
                        borderRadius: "10px",
                        backgroundColor: "white",
                        color: "black",
                        fontSize: "16px"
                      }}
                      component={RouterLink} to="/boards"
                      startIcon={<img src="/assets/login-icon-1.png" alt="" width={24} height={24} />}
                      size="large"
                      fullWidth
                      variant="contained">
                      Weiter geht´s
                    </Button>
                  </Box>
                </>
              )}

              <Box width="350px" py={1}>
                <Button
                  style={{
                    justifyContent: "flex-start",
                    padding: "16px 20px",
                    borderRadius: "10px",
                    backgroundColor: "white",
                    color: "black",
                    fontSize: "16px"
                  }}
                  startIcon={<img src="/assets/add-user.png" alt="" width={24} height={24} />}
                  size="large"
                  fullWidth
                  variant="contained"
                  onClick={() => {
                    modalStore.openModal(<MailRegisterForm />)
                  }}>
                  Du hast noch keinen Zugang?
                </Button>
              </Box>
            </Box>
          </Grid>

          <Grid item flex={0} position={"sticky"} bottom={0} bgcolor="#fff">
            <Box display="flex" gap={4} alignItems="center" justifyContent="center" p={2}>
              <img src="/assets/sponsor-2.png" alt="" width="auto" height="100px" />
              <img src="/assets/sponsor-1.png" alt="" width="auto" height="60px" />
            </Box>

            <Divider />

            <Box display="flex" gap={4} alignItems="center" justifyContent="center" p={2}>
              <Link href="https://cokomo-it.de/docs/" underline="none" color="black" fontSize="12px" fontWeight={500}> @2024 CoKoMo </Link>
              <Link href="https://cokomo-it.de/docs/datenschutzerklaerung/" underline="none" color="black" fontSize="12px" fontWeight={500}> Privacy Policiy </Link>
              <Link href="https://cokomo-it.de/docs/impressum/" underline="none" color="black" fontSize="12px" fontWeight={500}> Imprint </Link>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
});

function Dot(props: {
  size: string;
  color: string;
}) {
  return (
    <div style={{
      width: props.size,
      height: props.size,
      borderRadius: "50%",
      backgroundColor: props.color
    }}
    />
  )
}
